import { makeStyles, createStyles } from '@mui/styles'
import { Box } from '@mui/material'
import React from 'react'
import { checkActions } from '../actions/checkActions'
import { useCheck } from '../context/useCheck'

// import { CheckDispatchContext } from '../checkDispatchContext'
export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid silver',
      borderRadius: '18px',
      width: '300px',
      height: '30px',
      backgroundColor: '#fafafa'
    },
    input: {
      border: '0px',
      borderRadius: '18px',
      width: '150px',
      height: '30px',
      color: 'white',
      background: 'none',
      fontWeight: 'bold',
      fontSize: '14px',
      transition: 'background 1s ease'
    }
  })
)

export const SwitchCheckDispatch = () => {
  const classes = useStyles()
  const {
    state: { isWorkOrderId },
    dispatch
  } = useCheck()
  const { setIsWorkOrderId } = checkActions()

  const handleClick = (e: any) => {
    e.preventDefault()
    dispatch(setIsWorkOrderId(!isWorkOrderId))
  }

  return (
    <Box
      component='form'
      display='flex'
      flexDirection='row'
      flexWrap='nowrap'
      alignItems='center'
      p={1}
      m={1}
    >
      <div className={classes.container}>
        <button
          className={classes.input}
          style={{
            background: isWorkOrderId ? '#004bb1' : 'none',
            color: isWorkOrderId ? 'white' : '#6E6C6C'
          }}
          onClick={handleClick}
        >
          OT
        </button>
        <button
          className={classes.input}
          style={{
            background: isWorkOrderId ? 'none' : '#004bb1',
            color: isWorkOrderId ? '#6E6C6C' : 'white'
          }}
          onClick={handleClick}
        >
          Ruta de Picking
        </button>
      </div>
    </Box>
  )
}
